import $ from 'jquery';
window.jQuery = $;